import { ProjectsHall } from '@/pages/radar/ProjectsHall';

export function TrashPage() {
  return (
    <div className="space-y-5 p-6 lg:p-8">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight">回收站</h1>
        <p className="mt-1 text-sm text-neutral-600">
          已删除项目可在此恢复 · 永久删除后无法找回
        </p>
      </header>
      <ProjectsHall hideHeader trashed />
    </div>
  );
}
